import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import BenefitsSection from './components/BenefitsSection';
import CTASection from './components/CTASection';
import TrustSection from './components/TrustSection';
import ArticleSection from './components/ArticleSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryDropdown />
        <CategoryGrid />
        <WhatIsSection />
        <BenefitsSection />
        <CTASection />
        <TrustSection />
        <ArticleSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            'name': 'Sugargoo Spreadsheet',
            'url': 'https://sugargoospread.site/',
            'description': 'The ultimate Sugargoo Spreadsheet resource hub with updated product finds, reviews, shipping guides, coupons and expert shopping tips.',
            'potentialAction': {
              '@type': 'SearchAction',
              'target': 'https://sugargoospread.site/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </>
  );
}